export enum SellType {
    RESALE = 'resale',
    INITIAL_DROP = 'initial-drop'
}